import { Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { docData } from 'rxfire/firestore';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { purchases } from '../app.config';
import { environ, apiHost, appVersion } from '../app.config';

export interface AppVersion {
  major: number;
  minor: number;
  patch: number;
}

export interface AppConfig {
  version: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService implements OnDestroy {
  host: string; // Firebase static files host
  tokenUrl: string; // URL to make API calls to
  environment = environ; // Environment to use when building
  wrapper: AppVersion; // Version of the App Store wrapper (from device)

  localVersion: AppVersion; // Version of the "site" codebase (set by code)
  localVersionFull: string = null;
  remoteVersion: AppVersion; // Version of the "site" codebase (set by code)
  remoteVersionFull: string = null;

  appConfigSubscription: Subscription;

  trialProduct = 'qtft.001.trial.30';
  quarterlyProduct = 'qtft.001.premium.3';
  annualProduct = 'qtft.001.premium.12';
  mock: boolean; // IAP transactions
  purchasing = purchases;
  debugExpiration = false; // Artificially shortens expiration times (30 days = 3 minutes; 1 year = 1 hour)

  constructor() {
    this.mock = this.purchasing === 'mock' ? true : false; // IAP transactions
    this.environment = this.environment === 'local' ? 'emul' : this.environment;
    this.tokenUrl = `https://${apiHost}.afteraction.com/api/sendcode/api_${this.environment}.php`;
    // console.log(`token url: ${this.tokenUrl}`);

    // Set version of the "site" codebase according to the next scheduled release
    this.localVersion = appVersion;
    this.localVersionFull = `${this.localVersion.major}.${this.localVersion.minor}.${this.localVersion.patch}`;

    const db = firebase.firestore();
    const configCol = db.collection('app-configs');
    const configDoc = configCol.doc(this.environment);
    const config$ = docData(configDoc);
    this.appConfigSubscription = config$.subscribe((appConfig: AppConfig) => {
      console.log('Current config', appConfig);
      this.remoteVersionFull = appConfig.version;
      if (this.localVersionFull === this.remoteVersionFull) {
        console.log(
          `on version '${this.localVersionFull}', no updates available`
        );
        return;
      }

      const remoteVersion = this.remoteVersionFull.split('.');
      this.remoteVersion = {
        major: parseInt(remoteVersion[0], 10),
        minor: parseInt(remoteVersion[1], 10),
        patch: parseInt(remoteVersion[2], 10),
      };
      if (
        this.remoteVersion.major > this.localVersion.major ||
        (this.remoteVersion.major === this.localVersion.major &&
          this.remoteVersion.minor > this.localVersion.minor) ||
        (this.remoteVersion.major === this.localVersion.major &&
          this.remoteVersion.minor === this.localVersion.minor &&
          this.remoteVersion.patch > this.localVersion.patch)
      ) {
        console.log(
          `hosting update available from '${this.localVersionFull}' to '${this.remoteVersionFull}'`
        );
        window.location.reload();
      } else {
        console.log(
          `on version '${this.localVersionFull}', no updates available`
        );
      }
    });
  }

  ngOnDestroy() {
    if (this.appConfigSubscription) {
      this.appConfigSubscription.unsubscribe();
    }
  }
}
